import es from '@/locales/translations/es/es.json'
import common from '@/locales/translations/es/common.json'
import glossary from '@/locales/translations/es/glossary.json'
import validation from '@/locales/translations/es/validation.json'

export default {
  translation: es,
  common: common,
  glossary: glossary,
  validation: validation,
}
